import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { PERFORMANCE_KEYS } from 'FormsUI/constants/ComparisonTool';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPerformanceRowValue = ({
  fieldKey,
  formType,
  value
}) => {
  switch (fieldKey) {
    case PERFORMANCE_KEYS.VIEWS:
      if (formType === FormTypes.CAPTURED) return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notApplicable"
      });
      return /*#__PURE__*/_jsx("span", {
        children: value
      });
    case PERFORMANCE_KEYS.SUBMISSION_RATE:
      if (formType === FormTypes.CAPTURED) return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "notApplicable"
      });
      return /*#__PURE__*/_jsx(FormattedPercentage, {
        precision: 2,
        value: value * 100
      });
    default:
      return /*#__PURE__*/_jsx("span", {
        children: value
      });
  }
};
export default FormattedPerformanceRowValue;